import { PdOption, resolvePd } from '@order/hooks/state/orderState'
import { useOrderState } from '@order/hooks/useOrderState'
import useSession from 'hooks/useSession'
import { useCallback } from 'react'

export const useSaveOrderDefaults = () => {
  const setInfo = useSession((s) => s.setInfo)
  const prescriptionId = useOrderState((s) => s.order.prescriptionId)
  const pdState = useOrderState((s) => s.order.pd)

  const saveOrderDefaults = useCallback(() => {
    const resolvedPd = resolvePd(pdState)

    setInfo({
      lastUsedPrescriptionId: prescriptionId ?? undefined,
      lastUsedPd: resolvedPd ?? undefined,
      lastUsedPdOption: pdState.current ?? undefined,
    })
  }, [prescriptionId, pdState, setInfo])

  return { saveOrderDefaults }
}

export const useLastOrderDefaults = () => {
  const lastUsedPrescriptionId = useSession(
    (s) => s.info.lastUsedPrescriptionId
  )
  const lastUsedPd = useSession((s) => s.info.lastUsedPd)
  const lastUsedPdOption = useSession(
    (s) => s.info.lastUsedPdOption
  ) as PdOption | undefined

  return {
    lastUsedPrescriptionId,
    lastUsedPd,
    lastUsedPdOption,
  }
}
